import * as contentful from 'contentful';

export const client = contentful.createClient({
  space: 'wdwyfr5vp349',
  accessToken: 'zi3Gl21jMIMAcrPhYodIKYW6nEhOwJIEFfekYORi1Ps',
});
